const setSurveyTakingDocumentTitle = (isEnabled: boolean, isWhiteLabel: boolean, title = ''): string => {
  const defaultTitle = `${isWhiteLabel ? 'Research.net' : 'SurveyMonkey'} Powered Online Survey`;

  if (isEnabled) {
    return title.toLowerCase().includes('survey') ? title : `${title} Survey`;
  }
  return defaultTitle;
};

export default setSurveyTakingDocumentTitle;
